import api from "./api";

// Enum TipoDocumento — espelha o C# (ordem importa).
export const TIPO_DOCUMENTO = {
  Passaporte: 0,
  Voucher: 1,
  Bilhete: 2,
  Reserva: 3,
  Seguro: 4,
  Outro: 5,
};

export const TIPO_DOCUMENTO_LABEL = {
  0: "Passaporte",
  1: "Voucher",
  2: "Bilhete",
  3: "Reserva",
  4: "Seguro",
  5: "Outro",
};

export async function listByCliente(clienteId) {
  const { data } = await api.get(`/Documentos/cliente/${clienteId}`);
  return data;
}

export async function uploadDocumento({ arquivo, clienteId, tipo, roteiroId }) {
  const form = new FormData();
  form.append("arquivo", arquivo);
  form.append("clienteId", clienteId);
  form.append("tipo", tipo);
  if (roteiroId) form.append("roteiroId", roteiroId);
  const { data } = await api.post("/Documentos/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

// Baixa o arquivo forçando download pelo browser.
export async function downloadDocumento(id, nomeSugerido) {
  const res = await api.get(`/Documentos/download/${id}`, {
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = nomeSugerido || `documento-${id}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export async function deleteDocumento(id) {
  await api.delete(`/Documentos/${id}`);
}

// Extensões e tamanho máximo (10 MB) — mantidos aqui pra serem o mesmo gate
// que o backend aplica, e para o input file mostrar o accept certo.
export const ACCEPT_MIME = ".pdf,.jpg,.jpeg,.png";
export const MAX_SIZE_BYTES = 10 * 1024 * 1024;

export function formatBytes(bytes) {
  if (bytes == null) return "—";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
}
